import {Navigate, Route, Routes, useLocation} from "react-router";
import MainContainer from "./MainPage";
import {ConfigProvider, Empty} from "antd";
import LoginPage from "../pages/login/LoginPage";
import StatementsPage from "../pages/statements/StatementsPage";
import StatementsDetails from "../pages/statements/content/StatementsDetails";
import EducationPage from "../pages/education/EducationPage";
import StatementsList from "../pages/statements/content/StatementsList";
import TaskPage from "../pages/tasks/TaskPage";
import PlansPage from "../pages/plans/PlansPage";
import PlansList from "../pages/plans/content/PlansList";
import PlanDetail from "../pages/plans/content/PlanDetail";
import LoginContent from "../pages/login/content/LoginContent";
import PasswordRequestContent from "../pages/login/content/PasswordRequestContent";
import PasswordResetContent from "../pages/login/content/PasswordResetContent";
import CalendarPage from "../pages/calendar/CalendarPage";
import dayjs from "dayjs";
import locale from 'antd/locale/ru_RU';
import 'dayjs/locale/ru';
import WorkInProgress from "../pages/stub/WorkInProgres";
import SalaryPage from "../pages/salary/SalaryPage";
import AdmissionPage from "../pages/admissions/AdmissionPage";
import DocsPage from "../pages/docs/DocsPage";
import Registration from "../pages/login/content/Registration";
import AdmissionList from "../pages/admissions/AdmissionList";
import AdmissionSteps from "../pages/admissions/AdmissionSteps";
import EditConcourseGroups from "../pages/admissions/steps/edit/EditConcourseGroups";
import QueuePage from "../pages/queue/QueuePage";
import DispensaryPage from "../pages/dispensary/DispensaryPage";
import EditProfiles from "../pages/admissions/steps/edit/EditProfiles";
import EditConcourseGroupPriority from "../pages/admissions/steps/edit/EditConcourseGroupPriority";
import OlympiadPage from "../pages/olympiad/OlympiadPage";
import OlympiadList from "../pages/olympiad/content/list/OlympiadList";
import OlympiadDetails from "../pages/olympiad/content/OlympiadDetails";
import TeacherOlympiadList from "../pages/olympiad/content/teacher/TeacherOlympiadList";
import { userStore } from "../store/store";
import OrdersPage from "../pages/orders/OrdersPage";
import UsersPage from "../pages/users/UsersPage";
import MaintenancePage from "../pages/maintenance/MaintenancePage";

const restrictedHosts = ["fake.host"];

const withHostRestriction = (Component: React.ComponentType, restrictedPages: string[]) => {
    return function RestrictedComponent(props: any) {
        const location = useLocation();
        const isRestrictedHost = restrictedHosts.includes(window.location.hostname);
        const isRestrictedPath = restrictedPages.some(path => location.pathname.startsWith(path));

        if (isRestrictedHost && isRestrictedPath) {
            return <MaintenancePage />;
        }
        return <Component {...props} />;
    };
};

const RestrictedDocsPage = withHostRestriction(DocsPage, ["/documents"]);
const RestrictedAdmissionPage = withHostRestriction(AdmissionPage, ["/admission"]);

export default function MainRouter() {

    const location = useLocation();
    const {user, setUser} = userStore();
    var weekday = require('dayjs/plugin/weekday')
    dayjs.extend(weekday)
    dayjs().locale('ru')

    const customizeRenderEmpty = () => (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            imageStyle={{height: 60}}
            description={<span>Данные не найдены</span>}
        />
    );

    return (
        <ConfigProvider theme={{
            components: {
                Descriptions: {
                    itemPaddingBottom: 0
                },
                Table: {
                    cellFontSize: 12,
                },
                Layout: {
                    bodyBg: "rgb(227,234,250)",
                    footerBg: "rgb(227,234,250)",
                }
            }
        }}
                        locale={locale}
                        renderEmpty={customizeRenderEmpty}
        >
            <Routes>
                <Route path="/resetPass" element={<Navigate to={`/login/resetPass${location.search}`}/>}/>
                <Route path="/work-in-progress" element={<WorkInProgress/>}/>
                <Route path="/queue" element={<QueuePage/>}/>
                <Route path="/dispensary" element={<DispensaryPage/>}/>
                <Route path="/login" element={<LoginPage/>}>
                    <Route index element={<LoginContent/>}/>
                    <Route path="/login/restore"
                           element={<PasswordRequestContent/>}/>
                    <Route path="/login/resetPass" element={<PasswordResetContent/>}/>
                    <Route path="/login/registration" element={<Registration/>}/>
                </Route>
                <Route path="/" element={<MainContainer/>} key={"main"}>
                    <Route key={"statements"} path={"/statements"} element={<StatementsPage/>}>
                        <Route index element={<StatementsList/>}/>
                        <Route key={"statementDetails"} path={"/statements/details"}
                               element={<StatementsDetails/>}/>
                    </Route>
                    <Route key={"tasks"} path={"/tasks"} element={<TaskPage/>}/>
                    {/* <Route key={"documents"} path={"/documents"} element={<MaintenancePage/>}/> */}
                    <Route key={"documents"} path={"/documents"} element={<RestrictedDocsPage/>}/>
                    <Route key={"plans"} path={"/plans"} element={<PlansPage/>}>
                        <Route index element={<PlansList/>}/>
                        <Route key={"statementDetails"} path={"/plans/details"}
                               element={<PlanDetail/>}/>
                    </Route>

                    <Route key={"education"} path={"/education"} element={<EducationPage/>}/>
                    <Route key={"calendar"} path={"/calendar"} element={<CalendarPage/>}/>
                    <Route key={"salarys"} path={"/salarys"} element={<SalaryPage/>}/>
                    <Route key={"orders"} path={"/orders"} element={<OrdersPage/>}/>
                    <Route key={"olympiad"} path={"/olympiad"} element={<OlympiadPage/>}>
                        {user.roles.includes("OLYMPIAD_ADMIN") || user.roles.includes("OLYMPIAD_CURATOR") ?
                        <Route index element={<TeacherOlympiadList/>}/> :
                        <Route index element={<OlympiadList/>}/>
                        }
                        <Route key={"olympiadDetails"} path={"/olympiad/details"} element={<OlympiadDetails/>}/>
                    </Route>
                    <Route key={"admission"} path="/admission" element={<RestrictedAdmissionPage/>}>
                        <Route index element={<AdmissionList/>}/>
                        <Route key={"admissionSteps"} path={"/admission/steps"} element={<AdmissionSteps/>}/>
                        <Route key={"admissionSteps"} path={"/admission/edit"} element={<EditConcourseGroups/>}/>
                        <Route key={"admissionSteps"} path={"/admission/edit/priority"} element={<EditConcourseGroupPriority/>}/>
                        <Route key={"admissionSteps"} path={"/admission/profiles/edit"} element={<EditProfiles/>}/>
                    </Route>
                    <Route key={"users"} path={"/users"} element={<UsersPage/>}/>
                </Route>
            </Routes>
        </ConfigProvider>
    )
}